<template>
    <SectionViewLayout
      title="settings.filters.titles.list"
      :content_state="content_state"
      content_class="filters-info"
      close_route="filters-list"
      close_class="close">
        <template #actions>
            <ActionButton
                @click="onFilterEdit()"
                v-tooltip='"settings.filters.actions.edit"'
                icon="fas fa-cog"
            />
        </template>

        <template #content>
            <div class="bottom-space">
                <small>{{Language.say('settings.filters.labels.filter_name')}}</small>
                <p>{{filter.name}}</p>
            </div>

            <div class="bottom-space">
                <p>{{Language.say('settings.filters.labels.rules')}}</p>
                <div class="block" v-for="condition in filter.conditions" :key="condition">
                    <small>{{Language.say('settings.filters.labels.' + condition.field)}}</small>
                    <small>{{Language.say('settings.filters.labels.' + condition.test)}}</small>
                    <small>{{condition.value}}</small>
                </div>
            </div>

            <div class="bottom-space">
                <p>{{Language.say('settings.filters.labels.actions')}}</p>
                <small>{{Language.say('settings.filters.labels.' + filter.action)}}</small>
                <small class="block" v-if="props.filters_controller.data.metadata.actions.allowed_flags[filter.action]">
                    {{filter.action_value}}
                </small>
            </div>

            <div class="bottom-space" v-if="flags.length">
                  <p>{{Language.say('settings.filters.labels.filter_flags')}}</p>
                  <span v-for="flag,key in props.filters_controller.data.metadata.flags.values" :key="flag">
                    <small class="block" v-if="filter.flags[flag]">
                        {{Language.say('settings.filters.labels.' + key)}}
                    </small>
                </span>
            </div>

        </template>
    </SectionViewLayout>
</template>

<script setup>
  import { ref, defineProps, onBeforeMount } from 'vue';
  import { useRoute, useRouter }             from 'vue-router';
  import SectionViewLayout                from '@/vue/Layouts/Sections/SectionViewLayout.vue';
  import ActionButton                        from '@/vue/Elements/Buttons/ActionButton.vue'
  import Language                            from '@/js/Shared/Language/Language.js';

  const props = defineProps({
    filters_controller    : {},
    content_state         : {},
  })

  const route          = useRoute();
  const router         = useRouter();
  const filter         = ref();
  const flags          = ref();

  onBeforeMount(async () => {
    props.content_state.onLoaded(() => {
      setFilter();
      setFlags();
    })
  })

  const onActionClose = () => {
    router.push('/settings/filters');
  }

  const onFilterEdit = (id) => {
    router.push('/settings/filters/edit/' + filter.value.id);
  }

  const setFilter = (entity) => {
    filter.value = props.filters_controller.data.filters.get(route.params.id);
  }

  const setFlags = () => {
    flags.value = props.filters_controller.data.getFilterSelectedFlags(filter.value);
  }

</script>
